import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacyPolicy() {
  return <LegalPage slug="privacy-policy" fallbackTitle="Privacy Policy" />;
}
